export function loadCustomerList(range, sort, desc, keyword) {
  return {
    type: 'LOAD_CUSTOMER_LIST',
    range,
    sort,
    desc,
    keyword,
  };
}

export function loadCustomerListCompletion(range, data, error) {
  return {
    type: 'LOAD_CUSTOMER_LIST_COMPLETION',
    range,
    count: data && data.count,
    list: (data && data.listData) || [],
    error,
  };
}

export function loadCustomer(customerId) {
  return {
    type: 'LOAD_CUSTOMER',
    customerId,
  };
}

export function loadCustomerCompletion(customerId, data, error) {
  return {
    type: 'LOAD_CUSTOMER_COMPLETION',
    customerId,
    data,
    error,
  };
}
